import type { Dispatch, SetStateAction } from 'react';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Fade,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import type { MenuExtendedItem } from '@components/sidebar/types';

type MenuListItemProps = {
  item: MenuExtendedItem;
  isCollapsed: boolean;
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

export const MenuListItem = (props: MenuListItemProps) => {
  const { item, isCollapsed, isOpen, setOpen } = props;

  return (
    <ListItem
      sx={{ px: 1, color: 'inherit', gap: 2, pl: 1.25 }}
      secondaryAction={
        item.subItems?.length && (
          <Fade
            in={!isCollapsed}
            timeout={{
              appear: 500,
              enter: 500,
              exit: 200,
            }}
          >
            <IconButton
              onClick={event => {
                event.stopPropagation();
                event.preventDefault();
                setOpen(!isOpen);
              }}
              sx={{
                color: 'inherit',
              }}
            >
              {isOpen ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Fade>
        )
      }
    >
      <ListItemIcon
        sx={{
          color: 'inherit',
          minWidth: '24px',
          pl: '3px',
        }}
      >
        {item.icon}
      </ListItemIcon>
      <ListItemText
        sx={{
          overflow: 'hidden',
          '& > span': {
            minWidth: 219,
          },
        }}
      >
        {item.title}
      </ListItemText>
    </ListItem>
  );
};
